import script from "./my-number.vue?vue&type=script&setup=true&lang=js"
export * from "./my-number.vue?vue&type=script&setup=true&lang=js"

import "./my-number.vue?vue&type=style&index=0&id=63adc99d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63adc99d"]])

export default __exports__